class Utilities {
  static hasAccess(pageLevel) {
    const userLevel = sessionStorage.getItem("privilegeLevel");

    if (userLevel >= pageLevel) {
      return true;
    } else {
      return false;
    }
  }

  static validateLicense(types, contains) {
    if (!types || !contains) return false;

    return types
      .split(",")
      .map((word) => word.trim())
      .includes(contains);
  }

  static hasAgreedTerms() {
    return sessionStorage.getItem("termsAgreed");
  }

  static capitalizeFirstLetter = (string) => {
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  static validateField(field, values, setFormError) {
    let status = "";
    if (values[field] === "") {
      status = "This field is required";
    }

    if (status.length > 0 && setFormError) {
      setFormError(true);
    }
    return status;
  }

  static validateVlan = (field, values, setFormError) => {
    let status = "";
    if (values[field] < 3 || values[field] > 4094) {
      status = "VLAN must be an integer value between 3 and 4094";
    }

    if (status.length > 0 && setFormError) {
      setFormError(true);
    }
    return status;
  };

  static validateMacAddress = (field, values, setFormError) => {
    let status = "";
    if (values[field] === "") {
      status = "This field is required";
    }

    if (status == "") {
      const macAddressRegex = /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/;

      if (!macAddressRegex.test(values[field])) {
        status = "Invalid format. (XX:XX:XX:XX:XX:XX)";
      }
    }

    if (status.length > 0 && setFormError) {
      setFormError(true);
    }
    return status;
  };

  static handleInputChange(event, values, setValues) {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
    });
  }

  static handleSwitchChange = (e, values, setValues) => {
    const { props, state } = e;

    setValues({
      ...values,
      [props.name]: state.value,
    });
  };

  static LICENSE_PRO = "pro";
  static LICENSE_INSTALLATION = "installation";
}

export default Utilities;
